import { render, staticRenderFns } from "./EmployeeCalculation.vue?vue&type=template&id=0cbefeef&scoped=true"
import script from "./EmployeeCalculation.vue?vue&type=script&lang=js"
export * from "./EmployeeCalculation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCalculation.vue?vue&type=style&index=0&id=0cbefeef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbefeef",
  null
  
)

export default component.exports